export default "__VITE_ASSET__BGbvbNM7__"